import {REHYDRATE} from 'redux-persist';
import createReducer from '../util/createReducer';

const INITIAL_STATE = {
  'rehydrate': false,
};

export const rehydrate = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [REHYDRATE]: (state, action) => ({
      ...state,
      'rehydrate': true,
    }),
  })(state, action);
};
